import './styles.modules.scss';
import React, { useMemo } from 'react';
import InputQuantity from '../Quantity';
import { Product } from '~redux/brand/types';

type SingleRowProps = {
  product: Product;
  isCart?: boolean;
};

const SingleRow: React.FC<SingleRowProps> = ({ product, isCart }) => {
  const lot = useMemo(() => product.product_order_lot ?? 1, [product]);
  const min = useMemo(
    () =>
      Math.min(
        product.product_minimum_quantity ?? 1,
        product.product_order_lot ?? 1
      ),
    [product]
  );

  return (
    <div styleName="single-type-row">
      <div styleName="qty" className="w-100">
        <InputQuantity
          name={product.id!}
          minimum={min}
          lot={lot}
          brandId={product.product_brand_id!}
          productId={product.id!}
          sku={product.sku}
          cart={isCart}
        />
      </div>
    </div>
  );
};

export default SingleRow;
